import { IGeneralStats, IQuote } from './interfaces/general';

export interface WindowAccumulatedReturnResponse {
  nicename: string;
  slug: string | null;
  quotes: IQuote[];
}

type ITimeFrameHistory<T> = {
  hist_3_months: T;
  hist_6_months: T;
  hist_12_months: T;
  hist_24_months: T;
  hist_36_months: T;
  hist_48_months: T;
  hist_60_months: T;
  hist_120_months: T;
};

export interface SuccessRateResponse {
  nicename: string;
  slug: string;
  timeframe: ITimeFrameHistory<SuccessRateTimeFrame>;
}

export interface SuccessRateTimeFrame {
  success_percent: number;
}

export interface BoxPlotResponse {
  nicename: string;
  slug: string;
  timeframe: ITimeFrameHistory<HistoryTimeFrame>;
}

interface HistoryTimeFrame {
  min: number;
  max: number;
  median: number;
}

export interface CorrelationResponse {
  serie: {
    x: string;
    y: string;
    x_color: string;
    y_color: string;
    value: number;
  }[];
  period: { start_date: string; end_date: string };
}

export interface IMovableWindowSeries {
  nicename: string;
  slug: string | null;
  quotes: IQuote[];
}

export interface CorrelationBody {
  assets: Partial<CorrelationAssetsRequest>[];
  props?: {
    period: 'otimo';
    start_date: string | null;
    end_date: string | null;
  };
}

export interface CorrelationAssetsRequest {
  name?: string;
  id?: string;
  identifier: string; // use name instead of identifier
  color: string;
  quotes?: IQuote[];
}

export interface IGeneralStatsResponse extends IGeneralStats {
  nicename: string;
  shortname: string;
}

export interface IWalletSimulationBody {
  validation?: boolean;
  wallet: {
    assets: {
      initial_amount: number;
      identifier: string;
      buy_date: string | null; // yyyy-mm-dd
      sell_date: string | null; // yyyy-mm-dd
      display_name: string | null;
    }[];
    props: {
      generated_at: number;
      method: string;
      period: {
        start_date: string | null;
        end_date: string | null;
        period: string | null;
      };
      trading_currency?: string;
    };
  };
}

export interface IQuotedSimulationResponse {
  assets: IWalletAsset[];
  wallet: IQuotedWalletDetails;
}

interface IWalletAsset {
  id: number;
  identifier: string;
  nicename: string;
  display_name: string;
  class: string;
  canonical_url: string;
  start_value: {
    value: number;
    date: string;
  };
  final_value: {
    value: number;
    date: string;
  };
}

interface IQuotedWalletDetails {
  stats: any;
  years: any;
  wallet: any;
  props: {
    generated_at: number;
    method: string;
    period: {
      start_date: string;
      end_date: string;
      period: number | string;
    };
  };
}

export interface IIndexQuotes {
  nicename: string;
  quotes: IQuote[];
}

export interface FundsAdjustmentResponse {
  nicename: string;
  slug: string;
  adjustments: {
    start_applying_at: string;
    comment: string;
    adjustment_type: string;
  }[];
}

export enum GROUP_BY {
  TOTAL = 'all',
  CLASS = 'type',
  ASSET = 'asset',
}

export enum PERIOD_BY {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  SEMIANNUALLY = 'semiannual',
  ANNUAL = 'annual',
}
